import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'

import MenuItem from 'material-ui/MenuItem';

import Combobox from 'components/Combobox'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from '../selectors/common'
import { repairmen } from '../selectors/entities'

import { sortSev } from 'utils/stuff'

let select = dirtyRead(
	(state, props) => ({
		object: doc(state, props.objectID)
	  , repairmen: repairmen(state)
	})
)

export class RepairmanCombobox extends Component{
	render(){
		let { props } = this
		return(
			<Combobox
				icon={
					<img
						src={'/' + process.env.REACT_APP_NAME + "/static/img/svg-icon/repairmen_green.svg"}
						style={{
							width: "20px",
							marginTop: '0px'
					}}/>
				}
				link={`/manager/repairmen/${props.object.repairmanID}/`}
				exist={(props.object && props.object.repairmanID)}
				text={(props.object && props.object.repairmanID && props.repairmen[props.object.repairmanID])?props.repairmen[props.object.repairmanID].firstName:""}
				hintText={<span>Enter repairman name</span>}
				searchText={
					(props.object.repairmanID&&props.repairmen[props.object.repairmanID])?
						props.repairmen[props.object.repairmanID].firstName
						: ''
				}
				dataSource={
					R.map(repairman => ({
						text: `${repairman.firstName}`
					  , value: (
							<MenuItem
								key={repairman._id}
								primaryText={repairman.firstName}
							/>
						)
					  , id: repairman._id
				  }), sortSev(props.repairmen, "firstName", "lastName"))
				}
				onChange={(obj)=>{
						// if(props.object.ownerID && props.object.ownerID != obj.id){
						// 	props.STAGE({
						// 		_id: props.object.ownerID
						// 	  , properties:
						// 	  (
						// 		  props.owners[props.object.ownerID].properties
						// 		  && props.owners[props.object.ownerID].properties.length
						// 	  )?
						// 	  R.reject(property => property == props.objectID, props.owners[props.object.ownerID].properties)
						// 	  : []
						// 		})
						// }
						obj = obj || {}
						props.STAGE({
							_id: props.objectID
						  , repairmanID: obj.id
						})
						// if(props.owners[obj.id].properties&&!props.owners[obj.id].properties.length){
						// 	props.STAGE({
						// 			_id: obj.id
						// 		, properties: [props.objectID]
						// 	})
						// }
						// if(props.owners[obj.id].properties&&props.owners[obj.id].properties.length&&!R.contains(props.objectID, props.owners[obj.id].properties)){
						// 	props.STAGE({
						// 			_id: obj.id
						// 		, properties:
						// 		(
						// 			props.owners[obj.id].properties
						// 			&& props.owners[obj.id].properties.length
						// 		)?
						// 		[...props.owners[obj.id].properties, props.objectID]
						// 		: [props.objectID]
						// 	})
						// }
					}
				}
				// DELETE={()=>{
				// 	props.STAGE({
				// 		_id: props.object._id
				// 	  , repairmanID: ""
				// 	})
				// }}
			/>
		)
	}
}

export default connect(select, dataActions)(RepairmanCombobox)



// WEBPACK FOOTER //
// ./src/components/RepairmanCombobox.js